import React from "react";
import { Spinner } from "@material-tailwind/react";

const FullScreenSpinner = ({ display }) => {
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center backdrop-blur-sm z-50 transition-opacity duration-300 ${
        display ? "opacity-100 visible" : "opacity-0 invisible"
      }`}
    >
      <Spinner className="h-12 w-12" />
    </div>
  );
};

export default FullScreenSpinner;
